import React, { useContext, useState } from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import "./ClassCard.css";

import placeholder1 from "../../../../assets/images/class/class-placeholder-1.jpg";
import placeholder2 from "../../../../assets/images/class/class-placeholder-2.jpg";
import placeholder3 from "../../../../assets/images/class/class-placeholder-3.jpg";
import placeholder4 from "../../../../assets/images/class/class-placeholder-4.jpg";
import placeholder5 from "../../../../assets/images/class/class-placeholder-5.jpg";
import { AuthContext } from "../../../../context/AuthContext";

const ClassCard = ({ classData, onClick }) => {
  const { role } = useContext(AuthContext);
  const [userRole] = useState(role);

  // List of all placeholder images
  const placeholders = [
    placeholder1,
    placeholder2,
    placeholder3,
    placeholder4,
    placeholder5,
  ];

  // Deterministically pick an image based on the class name
  const getClassImage = () => {
    const uniqueValue = classData.class_name || "default";
    const index = Math.abs(
      [...uniqueValue].reduce((acc, char) => acc + char.charCodeAt(0), 0)
    ) % placeholders.length;
    return placeholders[index];
  };

  const classImage = getClassImage();

  // For students: count how many quizzes have attempts_count = 0
  const incompleteQuizzesCount = (classData.quizzes || []).filter(
    (quiz) => quiz.attempts_count === 0
  ).length;

  return (
    <Card className="class-card" onClick={onClick}>
      {/* If user is student and there's at least 1 quiz with attempts_count=0, show the badge */}
      {userRole === "student" && incompleteQuizzesCount > 0 && (
        <div className="quiz-badge">{incompleteQuizzesCount}</div>
      )}

      {/* Image Section */}
      <Box className="class-card-image-wrapper">
        <img src={classImage} alt="Class Placeholder" className="class-card-image" />
        <Box className="class-card-overlay">
          <Typography variant="h5" className="class-card-title-overlay">
            {classData.class_name}
          </Typography>
        </Box>
      </Box>

      {/* Content Section */}
      <CardContent className="card-content">
        {/* Description */}
        <Typography variant="body2" className="class-description">
          {classData.description || "No description available"}
        </Typography>
        {/* Student role: show teacher name + total quizzes (no full listing) */}
        {userRole === "student" && (
          <>
            {classData.teacher && (
              <Typography className="">
                Teacher:{" "}
                <span className="card-teacher-name"> {classData.teacher.teacher_profile?.full_name ||
                  classData.teacher.username ||
                  "Unknown Teacher"} </span>
              </Typography>

              
            )}
            <Typography variant="body2" className="quiz-count">
              Total Assessments: {classData.quizzes_count || 0}
            </Typography>
          </>
        )}

        {/* Unique Identifier */}
        {
            userRole !== "student" && (
                <Typography variant="body2" className="class-identifier">
                ID: {classData.unique_identifier || "Not Assigned"}
                </Typography>
            )
        }

        {/* Teacher role: show quiz count (existing logic) */}
        {userRole === "teacher" && (
          <Typography variant="body2" className="quiz-count">
            Assessments: {classData.quizzes?.length ?? classData.quizzes_count ?? 0}
          </Typography>
        )}

      </CardContent>

      {/* Hint (Hover) */}
      <Typography className="class-card-hint">
        {
          userRole === 'student' ? "Click to view " : "Click to manage "
        }&gt;&gt;
      </Typography>
    </Card>
  );
};

export default ClassCard;
